import React from "react";
import {
  Box,
  Typography,
  Divider,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
} from "@mui/material";
import Grid from '@mui/material/GridLegacy';
const InvoicePreview = () => {
  return (
    <Paper sx={{ borderRadius: 2, maxWidth: 900, margin: "auto" }}>
      <Box sx={{ px: 3, pt: 3, }}>
        {/* Header */}
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
          <Box>
            <Typography variant="h6" fontWeight="600" color="#1A1F36">
              Invoice Preview
            </Typography>
            <Typography variant="body2" color="#1A1F36" sx={{ fontSize: '10px', fontWeight: '500', }}>
              <Typography variant="span" sx={{ color: '#737982', fontSize: '10px' }}>Invoice Number:</Typography> <b>A1B2C3D4-0001</b>
            </Typography>
            <Typography variant="body2" color="#1A1F36" sx={{ fontSize: '10px', fontWeight: '500', }}>
              <Typography variant="span" sx={{ color: '#737982', fontSize: '10px' }}>Invoice Date:</Typography> <b>Jan 24, 2025</b>
            </Typography>
            <Typography variant="body2" color="#1A1F36" sx={{ fontSize: '10px', fontWeight: '500', }}>
              <Typography variant="span" sx={{ color: '#737982', fontSize: '10px' }}>Due Date: </Typography> <b>Feb 23, 2025</b>
            </Typography>
          </Box>
          <Box textAlign="right">
            <Box component="img" src="/assets/images/logo/logo.svg" alt="" sx={{ maxWidth: '100%', height: 'auto', }} />
            {/* <Typography variant="body2" color="#1A1F36" sx={{fontSize:'12px', fontWeight:'500',}}>
            support@timetrackr.com
          </Typography>
          <Typography variant="body2" color="#1A1F36" sx={{fontSize:'12px', fontWeight:'500',}}>
            +1 800-932-5330
          </Typography> */}
          </Box>
        </Box>

        <Divider sx={{ my: 2 }} />

        {/* Bill To / From */}
        <Grid container spacing={3} mb={3}>
          <Grid item xs={12} md={6}>
            <Box sx={{ borderRadius: '8.964px', border: '0.56px solid #EFF2F5', background: '#FBFCFE', padding: '10px 16px', height: '100%' }}>
              <Typography fontWeight="600" gutterBottom sx={{ color: '#0076FE' }}>
                To:
              </Typography>
              <Typography sx={{ color: '#1A1F36', fontWeight: 'bold', fontSize: '14px', mb: 1 }}>Netsoft Holdings, LLC</Typography>
              <Typography sx={{ color: '#1A1F36', fontWeight: '500', fontSize: '12px' }}>
                11650 Olio Rd. Suite #1000 - 193 Fishers, Indiana 46037
              </Typography>
              <Typography sx={{ color: '#1A1F36', fontWeight: '500', fontSize: '12px' }}>
                <Typography variant="span" sx={{ color: '#737982' }}>Email:</Typography>info@faizalgraphics.com</Typography>
              <Typography sx={{ color: '#1A1F36', fontWeight: '500', fontSize: '12px' }}>
                <Typography variant="span" sx={{ color: '#737982' }}>Phone:</Typography>+91 98765 43210</Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box sx={{ borderRadius: '8.964px', border: '0.56px solid #EFF2F5', background: '#FBFCFE', padding: '10px 16px', height: '100%' }}>
              <Typography fontWeight="600" gutterBottom sx={{ color: '#0076FE' }}>
                From:
              </Typography>
              <Typography sx={{ color: '#1A1F36', fontWeight: 'bold', fontSize: '14px', mb: 1 }}>
                Faizal Graphics</Typography>
              <Typography sx={{ color: '#1A1F36', fontWeight: '500', fontSize: '12px' }}> <Typography variant="span" sx={{ color: '#737982' }}>Email:</Typography> support@timetrackr.com</Typography>
              <Typography sx={{ color: '#1A1F36', fontWeight: '500', fontSize: '12px' }}> <Typography variant="span" sx={{ color: '#737982' }}>Phone:</Typography> +1 800-932-5330</Typography>
            </Box>
          </Grid>
        </Grid>

        {/* Items Table */}

        <Box className="table-responsive">
          <Table>
            <TableHead>
              <TableRow >
                <TableCell sx={{ color: '#fff', background: '#0076FE', borderRadius: '10px 0px 0 0' }}>Description</TableCell>
                <TableCell align="center" sx={{ color: '#fff', background: '#0076FE', }}>Quantity</TableCell>
                <TableCell align="right" sx={{ color: '#fff', background: '#0076FE', }}>Unit Price</TableCell>
                <TableCell align="right" sx={{ color: '#fff', background: '#0076FE', borderRadius: '0px 10px 0 0' }}>Total</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>
                  <Typography sx={{ fontWeight: 'bold', color: '#1A1F36', fontSize: '14px' }}>Starter — Monthly </Typography>
                  <Typography variant="caption" sx={{ fontWeight: '500', color: '#1A1F36', fontSize: '10px' }}>
                    Nov 30, 2023 - Dec 31, 2023
                  </Typography>
                </TableCell>
                <TableCell align="center" sx={{ fontWeight: 'bold', color: '#1A1F36', fontSize: '14px' }}>03</TableCell>
                <TableCell align="right" sx={{ fontWeight: 'bold', color: '#1A1F36', fontSize: '14px' }}>$10.00</TableCell>
                <TableCell align="right" sx={{ fontWeight: 'bold', color: '#1A1F36', fontSize: '14px' }}>$30.00</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Box>


        {/* Totals */}
        <Box display="flex" justifyContent="flex-end" mt={3} sx={{ gap: 1, flexWrap: 'wrap', flexDirection: 'column-reverse' }}>
          <Box>
            <Box sx={{ borderRadius: '8.964px', border: '0.56px solid #EFF2F5', background: '#FBFCFE', padding: '10px 16px', }}>
              <Typography fontWeight="600" gutterBottom sx={{ color: '#0076FE', fontSize: '14px' }}>
                Terms and Conditions
              </Typography>
              <Typography sx={{ color: '#1A1F36', fontWeight: '500', fontSize: '12px', mb: 0 }}>Please pay within 15 days from the date of invoice, overdue interest @ 14% will be charged on delayed payments. </Typography>
              <Typography sx={{ color: '#1A1F36', fontWeight: '500', fontSize: '12px', mb: 0 }}>Please quote invoice number when remitting funds. </Typography>
            </Box>
          </Box>
          <Box sx={{ width: '50%', marginLeft: 'auto' }}>
            <Box display="flex" justifyContent="space-between" mb={1}>
              <Typography sx={{ color: '#737982', fontWeight: '500', fontSize: '14px', mb: 1 }}>Sub Total:</Typography>
              <Typography sx={{ color: '#1A1F36', fontWeight: '600', fontSize: '14px', mb: 1 }}>$30.00</Typography>
            </Box>
            <Box display="flex" justifyContent="space-between" mb={1}>
              <Typography fontWeight="600" sx={{ color: '#737982', fontWeight: '500', fontSize: '14px', mb: 1 }}>Total:</Typography>
              <Typography fontWeight="600" sx={{ color: '#1A1F36', fontWeight: '600', fontSize: '14px', mb: 1 }}>$30.00</Typography>
            </Box>
            <Box display="flex" justifyContent="space-between" mb={1} sx={{ borderTop: "1px solid #ccc", pt: 1 }}>
              <Typography color="error" sx={{ color: '#1A1F36', fontWeight: '600', fontSize: '18px', mb: 1 }}>Amount Due:</Typography>
              <Typography color="error" sx={{ color: '#1A1F36', fontWeight: '600', fontSize: '18px', mb: 1 }}>$30.00</Typography>
            </Box>
          </Box>
        </Box>
        {/* Terms & Notes */}
      </Box>
      {/* Footer */}
      <Box textAlign="center" mt={5} borderTop="1px solid #E0E0E0" sx={{ background: '#0076FE', borderRadius: '0 0 10px 10px', py: 1 }}>
        <Typography variant="body2" color="#fff" sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1 }}>
          <Box component="img" src="assets/images/logo/logo-icon.svg" alt="" sx={{ maxWidth: '100%', width: '30px', }} /> Generated with TimeTrackr
        </Typography>
      </Box>
    </Paper>
  );
};

export default InvoicePreview;
